import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=a00fd704"
import script from "../../scripts/partials/Header.js?vue&type=script&lang=js&external"
export * from "../../scripts/partials/Header.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports